<!-- 
Contents of the SUMMARY tab of the role page.
-->
<template>
  <div>
    <our-heading 
      :next-page-action="nextPageAction"
      :previous-page-action="previousPageAction"
      :arrived-from-listing="arrivedFromListing"
      :breadcrumbs="breadcrumbs"
      :title="title"
      user-guide-topic="administration-roles-and-permissions"
      module="roles"
      nav-url="/roles/:id/summary"
    />
    <tabs :role-id="roleId">
      <role-summary-panel :role-id="roleId" />
    </tabs>
  </div>
</template>

<script>
import RoleSummaryPanel from "@/components/roles/RoleSummaryPanel.vue";
import Tabs from "./Tabs.vue";
import roleMixins from "./mixins";

export default {
  name: "RoleSummary",
  components: { Tabs, RoleSummaryPanel },
  mixins: [roleMixins]
};
</script>
